import { render, staticRenderFns } from "./WeeklyPresent.vue?vue&type=template&id=28821d30&scoped=true"
import script from "./WeeklyPresent.vue?vue&type=script&lang=js"
export * from "./WeeklyPresent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28821d30",
  null
  
)

export default component.exports